import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, select, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { alert } from "../../../../Utils/toast";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { queryClient } from "../../../store";
import {getProfileActions} from "../getProfile/getProfile";

export type ProfileUpdateLoadAction = {
  type: string;
  payload: {
    f_name?: string;
    l_name?: string;
  };
};

export type ProfileUpdateData = {
  data: {
    message: string;
    status?: string;
  };
};

const ProfileUpdate = new ReduxFetchState<
  ProfileUpdateData,
  {
    f_name?: string;
    l_name?: string;
  },
  any
>("profileUpdate");

export function* watchProfileUpdate(action: ProfileUpdateLoadAction) {
  try {
    const { f_name, l_name } = action.payload;
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: ProfileUpdateData = yield axios({
      url: "api/v1/users/profile/update",
      method: "POST",
      headers: {
        lang,
      },
      data: {
        f_name,
        l_name,
      },
    });
    yield alert({ message: data.data.message, type: "success" });
    queryClient.removeQueries({ queryKey: ["getProfile", lang] });
    queryClient.removeQueries({ queryKey: ["checkLogin", lang] });
    yield put(ProfileUpdate.actions.loadSuccess({ data: { ...data.data, status: "success" } }));
    yield put(getProfileActions.load());
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(ProfileUpdate.actions.loadFailure(e.message));
  }
}

export function* profileUpdateSagas() {
  yield takeEvery(ProfileUpdate.actionTypes.load, watchProfileUpdate);
}

export function useProfileUpdate() {
  const { loading, data, ...profileUpdateState } = useAppSelector((state) => state.profileUpdate);
  const dispatch = useAppDispatch();

  const dispatchProfileUpdate = useCallback(
    (data: { f_name?: string; l_name?: string }) => {
      dispatch(ProfileUpdate.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...profileUpdateState,
    dispatchProfileUpdate,
    profileUpdateLoading: loading,
    profileUpdateData: data,
  };
}

export const {
  actionTypes: profileUpdateActionsTypes,
  actions: profileUpdateActions,
  reducer: profileUpdateReducer,
} = ProfileUpdate;
